import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const salesforceTemplate = {
	id: 'salesforce',
	guid: '7452b26a-4635-474a-b0a2-e62ed3618896',
	name: 'Salesforce',
	category: TEMPLATE_CATEGORIES.CRM,
	popularity: 'Enterprise',
	color: '#00a1e0',
	icon: 'mdi-salesforce',
	description: 'Enterprise CRM integration with comprehensive customer relationship management.',
	features: ['OAuth2 Auth', 'Lead Management', 'Opportunity Tracking', 'Custom Objects'],
	configFields: [
		{ name: 'clientId', label: 'Client ID', type: 'text', required: true, placeholder: 'Enter your Salesforce client ID' },
		{ name: 'clientSecret', label: 'Client Secret', type: 'password', required: true, placeholder: 'Enter your Salesforce client secret' },
		{ name: 'username', label: 'Username', type: 'text', required: true, placeholder: 'Enter your Salesforce username' },
		{ name: 'password', label: 'Password', type: 'password', required: true, placeholder: 'Enter your Salesforce password' },
		{ name: 'instanceUrl', label: 'Instance URL', type: 'text', required: true, placeholder: 'https://yourinstance.my.salesforce.com' }
	],
	endpoints: [
		{
			name: 'Create Contact',
			url: '{instance_url}/services/data/v57.0/sobjects/Contact',
			method: 'POST',
			description: 'Create a new contact in Salesforce',
			cassieObjectID: -3,
			incrementField: 'syrenisID',
			resetIncrementValue: false,
			fields: [
				{ name: 'Email1', filter: '' },
				{ name: 'Forename', filter: '' },
				{ name: 'Surname', filter: '' },
				{ name: 'SyrenisID', filter: '' }
			],
			requestBody: '{"FirstName":"[PLACEHOLDER_FORENAME]", "LastName":"[PLACEHOLDER_SURNAME]", "Email":"[PLACEHOLDER_EMAIL1]", "CassieID__c":"[PLACEHOLDER_SYRENISID]"}',
			headers: [],
			successResponses: [{ code: 200, message: '' }, { code: 201, message: '' }]
		}],
	defaults: {
		endpointAddress: 'https://login.salesforce.com',
		authenticationUrl: 'https://login.salesforce.com/services/oauth2/authorize',
		authenticationTypeId: AUTH_TYPES.OAUTH2_CLIENT_CREDENTIALS,
		frequencyInSeconds: 0,
		auth2Scope: 'api refresh_token',
		notes: 'Salesforce CRM integration for enterprise-level customer relationship management and sales automation.'
	}
}
